import AppFunctions from '../helpers/AppFunctions'

export default {
    data() {
        return {
			categories: '',
            tags: '',
			
			edgeProductsIntroKey:'',
			edgeProductsIntro:[],			
			
			menuList: [
				{
					slug: '1',
					name: '边缘网关',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '0',
					name: 'MAC系列控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{
							slug: '2',
							name:'MAC中型控制器',
							isSelected:false,
						},
						{
							slug: '3',
							name:'MAC运动控制器',
							isSelected:false,
						}
					]
				},
				{
					slug: '0',
					name: '分布式控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{
							slug: '4',
							name: '以太网控制器',
							isSelected:false,
						},
						{
							slug: '5',
							name: '分布式扩展模块',
							isSelected:false,
						}							
					]
				},
				{
					slug: '6',
					name: 'EDC系列可编程嵌入式开发平台',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '7',
					name: 'CIO系列小型控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '0',
					name: '扩展IO模块',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{
							slug: '8',
							name: '开关量输入模块',
							isSelected:false,
						},
						{
							slug: '9',
							name: '开关量输出模块',
							isSelected:false,
						},
						{
							slug: '10',
							name: '模拟量输入模块',
							isSelected:false,
						},
						{
							slug: '11',
							name: '模拟量输出模块',
							isSelected:false,
						},
						{
							slug: '12',
							name: '模拟量输入输出模块',
							isSelected:false,
						}
						
					]
				},
				{
					slug: '13',
					name: '电源模块',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '14',
					name: '专用产品',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '0',
					name: '环网伺服器与伺服电机',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{
							slug: '15',
							name: '环网伺服器',
							isSelected:false,
						},
						{
							slug: '16',
							name: '伺服电机',
							isSelected:false,
						}
					]
				},
				{
					slug: '17',
					name: '软件产品',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				}
			],
            AppFunctions
        }
    },
    methods: { 
    
		/* 获取产品类型信息 */
		getCategoriesData(SerialID){
			let data = [];
			if(SerialID == 1){
				data=[
					{
						id: '1',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PAG310_1-1.jpg'),
						PTName:'PAG310',
						Resource:'数字量输入：5路，<br/>&emsp;&emsp;包含4路20kHz高速</br>数字量输出：2路</br>以太网(100M)：2路</br>RS485：4路',
						Intro:'支持MQTT、EPA、Profinet、EtherCAT、Ethernet/IP多种通信协议互联，支持Modbus TCP/UDP透明传输</br>支持边缘数据管理、设备变量映射管理、多协议功能块执行处理、控制网络互联。'
					},
					{
						id: '2',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PAG313_1-1.jpg'),
						PTName:'PAG313',
						Resource:'数字量输入：5路，<br/>&emsp;&emsp;包含4路20kHz高速</br>数字量输出：4路</br>以太网(100M)：2路</br>RS485：3路',
						Intro:'功能上与PAG310完全相同，舍弃一个RS485接口，换取2路数字量输出。'
					}
				]
			}
			else if(SerialID == 2){
				data=[
					{
						id: '3',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1100_1-1.jpg'),
						PTName:'MAC1100',
						Resource:'数字量输入：23路，<br/>&emsp;&emsp;包含4路20kHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'晶体管输出型'
					},
					{
						id: '4',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1110_1-1.jpg'),
						PTName:'MAC1110',
						Resource:'数字量输入：16路，<br/>&emsp;&emsp;包含4路20kHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型'
					},
					{
						id: '5',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1120_1-1.jpg'),
						PTName:'MAC1120',
						Resource:'数字量输入：24路，<br/>&emsp;&emsp;包含4路20kHz高速</br>数字量输出：12路，<br/>&emsp;&emsp;包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型</br>串口可与外部共地'
					}
				]
			}
			else if(SerialID == 3){
				data=[
					{
						id: '6',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC160_1-1.jpg'),
						PTName:'MAC160',
						Resource:'数字量输入：5路，<br/>&emsp;&emsp;包含4路500kHz高速</br>数字量输出：2路500KHz高速</br>以太网(100M)：2路</br>RS485：4路',
						Intro:'支持环网控制、单轴多轴轴组，支持G代码编程</br>支持单轴、多轴和轴组运动控制指令、数控G代码和多种机器人模型'
					},
					{
						id: '7',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1132_1-1.jpg'),
						PTName:'MAC1132',
						Resource:'数字量输入：23路，<br/>&emsp;&emsp;包含8路500kHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持单轴运动控制指令；支持4个实轴、4个虚轴'
					},
					{
						id: '8',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1133_1-1.jpg'),
						PTName:'MAC1133',
						Resource:'数字量输入：23路，<br/>&emsp;&emsp;包含8路500kHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持单轴运动控制指令；支持8个实轴、4个虚轴'
					},
					{
						id: '9',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1630_1-1.jpg'),
						PTName:'MAC1630',
						Resource:'数字量输入：23路，<br/>&emsp;&emsp;包含8路500kHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持8个实轴、4个虚轴和4个轴组</br>支持G代码编程</br>内置数控G代码与多种机器人模型'
					},
					{
						id: '10',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MAC1680_1-1.jpg'),
						PTName:'MAC1680',
						Resource:'数字量输入：35路，<br/>&emsp;&emsp;包含4路500kHz高速</br>数字量输出：24路500KHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持8个实轴、4个虚轴和4个轴组</br>支持G代码编程</br>内置数控G代码与多种机器人模型'
					}
				]
			}
			else if(SerialID == 4){
				data = [
					{
						id: '11',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PEC3000_1-1.jpg'),
						PTName:'PEC3000',
						Resource:'数字量输入：24路，<br/>&emsp;&emsp;包含4路500KHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含2路30KHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:''
					},
					{
						id: '12',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PEC5000_aodo_1-1.jpg'),
						PTName:'PEC5000',
						Resource:'数字量输入：1路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'包含模拟量输出款。即端口资源为：</br>数字量输入：1路</br>数字量输出：1路</br>模拟量输入：8路<br/>模拟量输出：8路'
					},					
					{
						id: '13',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PEC8000_1-1.jpg'),
						PTName:'PEC8000',
						Resource:'数字量输入：8路，<br/>&emsp;&emsp;包含4路500KHz高速</br>数字量输出：8路，<br/>&emsp;&emsp;包含2路30KHz高速</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：1路</br>RS485：2路',
						Intro:''
					}
				]
			}
			else if(SerialID == 5){
				data = [
					{
						id: '14',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/AIO5000_aodo_1-1.jpg'),
						PTName:'AIO5000',
						Resource:'数字量输入：1路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路',
						Intro:'从设备扩展模块，无以太网</br>包含模拟量输出款。即端口资源为：<br/>数字量输入：1路</br>数字量输出：1路</br>模拟量输入：8路<br/>模拟量输出：8路'
					},
					{
						id: '16',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/DIO2000_1-1.jpg'),
						PTName:'DIO2000',
						Resource:'数字量输入：23路</br>数字量输出：12路</br>模拟量输入：无<br/>模拟量输出：2路</br>以太网(100M)：无</br>RS485：1路',
						Intro:'不支持编程功能'
					},
					{
						id: '15',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/DIO3000_1-1.jpg'),
						PTName:'DIO3000',
						Resource:'数字量输入：24路，<br/>&emsp;&emsp;包含4路高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含2路高速</br>模拟量输入：无<br/>模拟量输出：2路</br>以太网(100M)：无</br>RS485：2路',				
						Intro:'从设备扩展模块，无以太网'
					},
					// {
					// 	id: '17',
					// 	thumbnail:require('@/assets/images/edge/placeholder/GRI16H.png'),
					// 	PTName:'GRI16H',
					// 	Resource:'16路DI</br>16路DO',
					// 	Intro:'继电器驱动板'
					// },
					// {
					// 	id: '18',
					// 	thumbnail:require('@/assets/images/edge/placeholder/GP16H.png'),
					// 	PTName:'GP16H',
					// 	Resource:'16路DI</br>16路DO',
					// 	Intro:'IO驱动板'
					// }
				]
			}
			else if(SerialID == 6){
				data = [					
					{
						id: '22',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EDC3200_1-1.jpg'),
						PTName:'EDC3200',
						Resource:'数字量输入：24路</br>数字量输出：16路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型'
					},
					{
						id: '20',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EDC5000_aodo_1-1.jpg'),
						PTName:'EDC5000',
						Resource:'数字量输入：4路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'包含模拟量输出款，即端口资源为：</br>数字量输入：4路</br>数字量输出：无</br>模拟量输入：8路<br/>模拟量输出：9路'
					},
					{
						id: '19',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EDC8000_1-1.jpg'),
						PTName:'EDC8000',
						Resource:'数字量输入：8路500KHz高速</br>数字量输出：9路，<br/>&emsp;&emsp;包含2路30KHz高速</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'混合型嵌入式开发平台'
					},
				]
			}
			else if(SerialID == 7){
				data = [
					{
						id: '23',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CIO110_1-1.jpg'),
						PTName:'CIO110',
						Resource:'数字量输入：11路，<br/>&emsp;&emsp;包含4路20KHz高速</br>数字量输出：8路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路',
						Intro:'晶体管输出</br>单层壳体'
					},
					{
						id: '25',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CIO200_1-1.jpg'),
						PTName:'CIO200',
						Resource:'数字量输入：16路</br>数字量输出：12路，<br/>&emsp;&emsp;包含2路100KHz高速</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路</br>RS232：1路',
						Intro:'卧式壳体</br>端子接线'
					},
					{
						id: '26',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CIO210_1-1.jpg'),
						PTName:'CIO210',
						Resource:'数字量输入：16路，<br/>&emsp;&emsp;包含4路50KHz高速</br>数字量输出：16路，<br/>&emsp;&emsp;包含2路100KHz高速</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路</br>RS232：1路',
						Intro:'卧式壳体</br>具有高速输入通道'
					},
					{
						id: '24',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CIO314_1-1.jpg'),
						PTName:'CIO314',
						Resource:'数字量输入：15路，<br/>&emsp;&emsp;包含4路20KHz高速</br>数字量输出：10路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：3路',
						Intro:'继电器输出</br>220V供电'
					}
				]
			}
			else if(SerialID == 8){
				data = [
					{
						id: '27',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EIO102&103_1-1.jpg'),
						PTName:'EIO102&103',
						Resource:'EIO102：16路数字量输入<br/>EIO103：20路数字量输入',
						Intro:'双向输入模块'
					}
				]
			}
			else if(SerialID == 9){
				data = [
					{
						id: '29',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EIO162&162P_1-1.jpg'),
						PTName:'EIO162&162P',
						Resource:'16路晶体管输出',
						Intro:'EIO162：NPN输出型<br/>EIO162P：PNP输出'
					},
					{
						id: '31',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EIO163&163P_1-1.jpg'),
						PTName:'EIO163&163P',
						Resource:'20路晶体管输出',
						Intro:'EIO163：NPN输出型<br/>EIO163P：PNP输出'
					},
					{
						id: '33',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EIO171&172_1-1.jpg'),
						PTName:'EIO171&172',
						Resource:'EIO171：8路继电器输出<br/>EIO172：16路继电器输出',
						Intro:''
					}
				]
			}
			else if(SerialID == 10){
				data = [
					{
						id: '35',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA200_1-1.jpg'),
						PTName:'EA20x系列',
						Resource:'EA201 4~20mA和0~5V</br>EA202 热电偶</br>EA203 PT100热电阻</br>EA204 -10~+10V</br>EA205 PT1000热电阻</br>EA206 高精度PT1000热电阻</br>EA207 S/R铂热电偶</br>EA208 B铂热电偶',
						Intro:'6路模拟量输入，支持各种通道类型'
					},
					{
						id: '36',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA210_1-1.jpg'),
						PTName:'EA21x系列',
						Resource:'EA211 4~20mA和0~5V</br>EA212 热电偶</br>EA213 PT100热电阻</br>EA214 -10~+10V</br>EA215 PT1000热电阻</br>EA216 高精度PT1000热电阻</br>EA217 S/R铂热电偶</br>EA218 B铂热电偶',
						Intro:'8路模拟量输入，支持各种通道类型'
					},
					{
						id: '37',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA120_1-1.jpg'),
						PTName:'EA122',
						Resource:'12路热电偶模拟量输入',
						Intro:'12路输入'
					},
					{
						id: '38',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA130_1-1.jpg'),
						PTName:'EA131',
						Resource:'8路0~20mA和0~5V模拟量输入',
						Intro:'8路全部支持高速电流电压输入'
					}
				]
			}
			else if(SerialID == 11){
				data = [
					{
						id: '39',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA155&156_1-1.jpg'),
						PTName:'EA155&156',
						Resource:'EA155 4路0~20mA模拟量输出</br>EA156 8路0~20mA模拟量输出',
						Intro:'0~20mA电流输出'
					},
					{
						id: '40',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA165&166_1-1.jpg'),
						PTName:'EA165&166',
						Resource:'EA165 4路0~20V模拟量输出</br>EA166 8路0~20V模拟量输出',
						Intro:'0~20V电压输出'
					},
					{
						id: '41',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA167&168_1-1.jpg'),
						PTName:'EA167&168',
						Resource:'EA167 4路-10~10V模拟量输出</br>EA168 8路-10~10V模拟量输出',
						Intro:'-10~10V电压输出'
					}
				]				
			}
			else if(SerialID == 12){
				data = [
					{
						id: '42',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA170_1-1.jpg'),
						PTName:'EA171~175',
						Resource:'EA171 4路0-5V/4-20mA模拟量输入</br>EA172 4路热电偶模拟量输入</br>EA173 4路PT100热电阻模拟量输入</br>EA174 4路-5~5V/-20~20mA模拟量输入</br>EA175 4路PT1000热电阻模拟量输入</br></br>输出通道共4路，通道类型统一为 2路4-20mA + 2路0-20V 模拟量输出',
						Intro:'8路模拟量输入输出模块。</br>其中包含4路输入，输入通道类型各不相同;</br>以及4路输出，输出通道类型一致'
					},
					{
						id: '43',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EA170_1-1.jpg'),
						PTName:'EA176~178',
						Resource:'EA176 高精度4路PT1000热电阻模拟量输入</br>EA177 高精度4路PT1000热电阻模拟量输入</br>EA178 高精度4路S/R铂热电偶模拟量输入',
						Intro:`8路模拟量输入输出模块。</br>其中包含4路输入，输入通道类型各不相同;</br>以及4路输出，输出通道类型一致
						</br>支持高精度模拟量输入`
					}
				]
			}
			else if(SerialID == 13){
				data = [
					{
						id: '44',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CPS200_1-1.jpg'),
						PTName:'CPS200',
						Resource:'功率100W,</br>输入150~260VA</br>输出2组隔离24V输出，每组额定电流4A',
						Intro:'具有2组隔离24V输出'
					}
				]
			}
			else if(SerialID == 14){
				data = [
					{
						id: '45',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/EPM102_1-1.jpg'),
						PTName:'EPM102',
						Resource:'3路0~9V电压交流输入，分辨率0.5V</br>9路0~5A电流交流输入，分辨率0.5A</br>工频频率：0~400HZ，分辨率:0.5Hz。</br>功率因数:-1.000~1.000;</br>分辨率：0.1%',
						Intro:'用于电力监控</br>3路交流电压输入，9路交流电流输入'
					},
					// {
					// 	id: '46',
					// 	thumbnail:require('@/assets/images/edge/placeholder/LAC100.png'),
					// 	PTName:'LAC100',
					// 	Resource:'6 路电流型输出，</br>2路电压输出；</br>6路开关量输入</br>10路开关量输出；</br>1路RS485，</br>1路RS232',
					// 	Intro:'用于灯光控制'
					// },
					{
						id: '47',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/TAC6000_1-1.png'),
						PTName:'TAC6000',
						Resource:'数字量输入：3路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路',
						Intro:'温控模块'
					},
					{
						id: '48',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/TAM4000_1-1.png'),
						PTName:'TAM4000',
						Resource:'数字量输入：3路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路',
						Intro:'温度采集模块，</br>不支持编程功能'
					},
					{
						id: '49',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/NCC2040_1-1.jpg'),
						PTName:'NCC2040',
						Resource:'数字量输入：12路，全部是探丝器</br>数字量输出：24路，其中12路切丝器，12路指示灯<br/>RS485：1路',
						Intro:'纺织机械专用产品，</br>支持可编程控制'
					},
					{
						id: '50',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/MCD1000_1-1.jpg'),
						PTName:'MCD1000',
						Resource:'数字量输入：32路</br>数字量输出：16路</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：2路</br>RS485：2路',
						Intro:'起重机监控控制器'
					}
				]
			}
			else if(SerialID == 15){
				data=[
					{
						id: '51',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/CUS_N_1-1.jpg'),
						PTName:'CUS00x<br/>系列',
						Resource:'输入3相220V AC，</br>数字量输入：10路</br>数字量输出：6路</br>2路0~10V输入，</br>1路-10V~+10V输入，</br>2路0~3V输出，</br>以太网(100M)：2路，</br>RS485：1路。',
						Intro:'支持回原点、往复运动、恒速运动、定位控制和手轮控制等功能'
					}
				]
			}
			else if(SerialID == 16){
				data=[
					{
						id: '52',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/xxkw_1-1.jpg'),
						PTName:'60SFM<br/>-系列',
						Resource:'0.2kw~2.0kw',
						Intro:''
					}
				]
			}
			else if(SerialID == 17){
				data=[
					{
						id: '53',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/PLCConfig_1-1.png'),
						PTName:'PLC_Config',
						Resource:'功能块编程<br/>梯形图编程',
						Intro:'公司专为各系列可编程控制器进行逻辑编程而自主开发的T型图，功能块组态软件。'
					},
					{
						id: '54',
						thumbnail:require('@/assets/images/edge/products/Nav_1-1/Dview_1-1.png'),
						PTName:'DView HMI',
						Resource:'设备拓扑<br/>组态编程',
						Intro:'公司自主研发的具有设备管理、实时数据管理、视频管理、数据库管理和地理信息管理等功能的监控管理系统开发平台。'
					}
				]
			}
			this.edgeProductsIntroKey = SerialID;
			this.edgeProductsIntro = data;
						
			// console.log("edgeProductsIntroKey="+this.edgeProductsIntroKey+",edgeProductsIntro=")
			// console.log(this.edgeProductsIntro)
		},

	},
    created() {

    }
}